import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-quienes-somos',
  templateUrl: './quienes-somos.component.html',
  styleUrls: ['./quienes-somos.component.scss']
})
export class QuienesSomosComponent implements OnInit {

  url: string = environment.configUrl;
  conf: any
  constructor(private http: HttpClient,) { }

  ngOnInit() {
    this.http.get(this.url).subscribe(res => {
      this.conf = res;
    });
  }


}
